import Vue from 'vue'
import Vuex from 'vuex'
import { HeNanIds, ZhengZhouMode } from "@/utils/config";

Vue.use(Vuex)
let _vm = new Vue()

export default {
  namespaced: true,
  state: {
    list: [],
    sortMap: {}, // 不同类别map
    codeMap: {}, // 不同值map
    operate: { // 操作时的临时数据
      labels: [],
      persons: [],
      personsData: []
    },
    confirm: { // 确认订单选择的数据
      labels: [],
      persons: [],
      personsData: []
    }
  },
  mutations: {
    // data: { key: state中需要改变值的key名，传数组支持深度赋值(eval处理), value: 赋值的数据 }
    setStore(state, data) {
      let key = data.key
      if (Array.isArray(key)) {
        let zhizhen = ''
        while (key.length > 0) {
          zhizhen += "['" + key.shift() + "']"
        }
        eval("state" + zhizhen + '=' + JSON.stringify(data.value))
      } else {
        state[data.key] = data.value
      }
    },
    syncData(state, keys) { // 同步数据 操作的数据同步到确认中  一般发起搜索成功之后触发，传数组或一个字符串
      keys = Array.isArray(keys) ? keys : [keys] // 传一个key也可以 这里自动转成数组
      keys.forEach(str => {
        state.confirm[str] = JSON.parse(JSON.stringify(state.operate[str]))
      })
    },
  },
  actions: {
    async getSearchLabels({ commit, rootState }) {
      const res = await _vm.fetch('/boss/deviceSlot/v2/labels', '', 'get')
      if (res && res.code === 0 && res.data && res.data.length > 0) {
        const labelAll = res.data || []
        commit('setStore', { key: 'list', value: labelAll })
        const { codeMap, sortMap } = handleMap(labelAll, rootState.customer.userChargeTypes)
        commit('setStore', { key: 'codeMap', value: codeMap })
        commit('setStore', { key: 'sortMap', value: sortMap })
      }
    }
  }
}

/**
 *
 * @param {Array} labelArr 全量标签数组
 * @param {Array} chargeCodes 当前用户有权限的收费方式(通过接口 chargeTypesForUser 获取)
 */
function handleMap(labelArr, chargeCodes) {
  console.log('收费方式编码:', chargeCodes)
  let codeMap = {}, sortMap = {}
  labelArr.forEach(({ kind, kindName, groups }) => {
    if (groups && groups.length) {
      groups.forEach(ele => {
        const { group, groupName } = ele
        // if (group === 'CHARGE_TYPE' && uid && HeNanIds.concat(ZhengZhouMode).indexOf(uid) > -1) {
        //   ele.labels = ele.labels.filter(e => ['L1', 'L2', 'L3'].indexOf(e.code) > -1)
        // }
        // 根据后台配置限制用户可见的收费方式 - 20240409
        if (group === 'CHARGE_TYPE') {
          ele.labels = ele.labels.filter(t => chargeCodes.indexOf(t.code) > -1)
        }
        ele.labels && ele.labels.length && ele.labels.forEach(label => {
          label.kind = kind
          label.kindName = kindName
          label.group = group
          label.groupName = groupName
          codeMap[label.code] = label
        })
        sortMap[ele.group] = ele.labels || []
      })
    }
  })
  return { codeMap, sortMap }
}
